import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button, InputNumber, Input } from 'antd';
import isEmpty from 'lodash/isEmpty';

import { FILTER_TYPE } from '../../../../data/config/constants';

import './index.scss';

import CheckboxGroupItem from '../../../../components/form/checkboxgroupitem'
import ErrorBoundary  from '../../../../components/errorboundary'

const Panel = Collapse.Panel;

const Filters = ({
  filters,
  selected_filters,
  handleFilterUpdate,
  handleClearFilter,
  handleApplyFilter,
  container_height
}) => {
  return (
    <div
      className="ori-overflow-auto oriFiltersContainer"
      style={{ maxHeight: container_height }}
    >
      <Collapse
        bordered={false}
        accordion
      >
        {
          filters.map(filter => {
            if (filter.type === FILTER_TYPE.INPUT_NUMBER) {
              return (
                <Panel
                  header={<span className="ori-capitalize">{filter.name}</span>}
                  key={filter.name}
                  className="filterPanel"
                >
                  <div className="ori-lr-pad-15 ori-b-pad-15 ori-flex-row inputNumberContainer">
                    <div className="ori-r-mrgn-10 ori-font-xs ori-font-light title ">
                      Enter {filter.name}
                    </div>
                    <InputNumber
                      min={0}
                      size="small"
                      className="inputBox"
                      value={!isEmpty(selected_filters) && selected_filters[filter.filterKey] && selected_filters[filter.filterKey] !== undefined && selected_filters[filter.filterKey].length > 0 ? selected_filters[filter.filterKey][0].value : ""}
                      onChange={value => {
                        let input_data = [{
                          id: `#${filter.type}${filter.filterKey}`,
                          filterKey: filter.filterKey,
                          value: value,
                          label: value,
                        }];
                        handleFilterUpdate(filter.filterKey, input_data);
                      }}
                    />
                  </div>
                </Panel>
              );
            } else if (filter.type === FILTER_TYPE.INPUT_STRING) {
              return (
                <Panel
                  header={<span className="ori-capitalize">{filter.name}</span>}
                  key={filter.name}
                  className="filterPanel"
                >
                  <div className="ori-lr-pad-15 ori-b-pad-15">
                    <Input
                      className="ori-font-xs"
                      size="small"
                      placeholder={filter.name}
                      value={!isEmpty(selected_filters) && selected_filters[filter.filterKey] && selected_filters[filter.filterKey] !== undefined && selected_filters[filter.filterKey].length > 0 ? selected_filters[filter.filterKey][0].value : ""}
                      onChange={event => {
                        let input_data = [{
                          id: `#${filter.type}${filter.filterKey}`,
                          filterKey: filter.filterKey,
                          value: event.target.value,
                          label: event.target.value,
                        }];
                        handleFilterUpdate(filter.filterKey, input_data);
                      }}
                    />
                  </div>
                </Panel>
              );
            }
            else if (filter.type === FILTER_TYPE.CHECKBOX) {
              return (
                <Panel
                  header={<span className="ori-capitalize">{filter.name}</span>}
                  key={filter.name}
                  className="filterPanel"
                >
                  <ErrorBoundary>
                    <CheckboxGroupItem
                      container_class="ori-lr-pad-15 ori-b-pad-15"
                      options={filter.representation}
                      checked_items={selected_filters[filter.filterKey]}
                      onChange={checkedValue => handleFilterUpdate(filter.filterKey, checkedValue)}
                      display_count={10}
                      show_search
                      select_option_object
                    />
                  </ErrorBoundary>
                </Panel>
              )
            }
          })
        }
      </Collapse>
      <div className="ori-pad-15 ori-flex-row ori-flex-jc ">
        <Button
          className="ori-r-mrgn-10 ori-font-xs ori-border-radius-20 ori-btn-ghost-primary"
          onClick={handleClearFilter}
        >
          Clear
            </Button>
        <Button
          type="primary"
          className="ori-font-xs ori-border-radius-20"
          onClick={handleApplyFilter}
        >
          Apply
        </Button>
      </div>
    </div>
  );
}


Filters.propTypes = {
  selected_filters: PropTypes.object,
  filters: PropTypes.array.isRequired,
  handleFilterUpdate: PropTypes.func,
  handleClearFilter: PropTypes.func,
  handleApplyFilter: PropTypes.func,
  container_height: PropTypes.number,
};

export default Filters;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/filters/index.js